/**
 * BOM 群組內物料／位置排序（對齊 v1 sortPositions）。
 */

export function sortBomMaterialsByCode(materials = []) {
  return [...materials].sort((left, right) => {
    const codeA = left?.mtrNo || left?.mtrId || '';
    const codeB = right?.mtrNo || right?.mtrId || '';
    return codeA.localeCompare(codeB, undefined, {
      numeric: true,
      sensitivity: 'base',
    });
  });
}

export function sortBomPositionsByName(positions = []) {
  return [...positions].sort((left, right) => (
    (left?.name || '').localeCompare(right?.name || '', undefined, {
      numeric: true,
      sensitivity: 'base',
    })
  ));
}
